/**
 * 导购模块（flashproduct）商品展示样式规则，https://www.tapd.cn/20269511/markdown_wikis/show/#1120269511001004489@toc17
 * 活动模式 - 主图 + 库存 + action
 * normal模式 - 主图 + 价格 + name + 库存 + action
 * 备注： 移动端的一列模式只有normal模式
 */

export const hasActView = (columnNum: number) => {
	return ![1].includes(columnNum);
};

export interface FlashProductDisplayExtend {
	showName: boolean;
	showPrice: boolean;
}
export const getFlashProductDisplayExtend = (
	isAct: boolean,
	columnNum: number = 2,
): FlashProductDisplayExtend => {
	if (isAct && hasActView(columnNum)) {
		return {
			showName: false,
			showPrice: false,
		};
	}

	return {
		showName: true,
		showPrice: true,
	};
};

export const isSoldOut = (soldout: boolean, columnNum: number) => {
	return soldout && hasActView(columnNum);
};
const formatTime = (t: number) => {
	if (t <= 0) {
		return "00";
	}
	return t > 9 ? `${t}` : `0${t}`;
};
// 秒转化为时分秒
export const formatSecToDate = (t: number) => {
	const hour = formatTime(Math.floor(t / 3600));
	const min = formatTime(Math.floor((t / 60) % 60));
	const sec = formatTime(Math.floor(t % 60));
	return `Ends in ${hour}:${min}:${sec}`;
};
